import validators from '../../../../utilities/validators';

const validator = () =>
    validators.compose(
        validators.requiredNonEmptyString('displayName'),
        validators.requiredString('apiKey'),
        validators.requiredString('apiToken'),
        validators.requiredString('apiEndpoint'),
        validators.requiredString('apiVersion'),
        validators.requiredNumber('concurrentTasks'),
        validators.requiredNumber('concurrentSeconds')
    );

export default validator;
